// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2JwV_","rightAdornment":"Header_rightAdornment__HOrUc"};